import React, { Component, createContext } from 'react';
import { fetchACL, logoutAdmin } from '../utils';

const PermissionContext = createContext(null);

class PermissionProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      userPermissions: {},
    };
  }

  componentDidMount() {
    let state = {};

    fetchACL()
      .then((acl) => {
        if (!acl) {
          logoutAdmin();
        }

        state = {
          loading: false,
          userPermissions: acl,
        };
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.setState(state);
      });
  }

  hasPermission = (resource, actionGuard = '') => {
    if (!resource || !actionGuard) {
      return true;
    }

    const { userPermissions } = this.state;

    const hasPermission = (userPermissions[resource] || []).some(
      (action) =>
        actionGuard.toLowerCase() === action.toLowerCase() || action === '*'
    );

    if (!hasPermission) {
      return false;
    }

    return true;
  };

  render() {
    // PermissionContext.Provider must be present from the first render for the
    // same reason as AdminUserContext.Provider — see AdminUserContext.js.
    return (
      <PermissionContext.Provider value={{ hasPermission: this.hasPermission }}>
        {this.state.loading ? <div>Loading...</div> : this.props.children}
      </PermissionContext.Provider>
    );
  }
}

export { PermissionContext, PermissionProvider };
